import React from "react";
import "./Simple.css";
import { DigitalImg } from "../../assets/images";
import homeData from "../../shared/data/homeData.json";
import aboutData from "../../shared/data/aboutData.json";
import { OurClients, ServiceComponent } from "../Home/Home";
import TestimonialPage from "../../components/Testimonial/Testimonial";
import { ToggleMode } from "../../components/Navbar/Nav";
import { useNavigate } from "react-router-dom";

const SimpleMode = () => {
  const { sections } = aboutData;
  const navigate = useNavigate()
  return (
    <div className="body-container">
      <div className="toggle-s-mode">
        <ToggleMode />
      </div>
      <div className="hero-area">
        <div className="left-s-cont">
          <p className="hero-txt-title">Unleash the Web with Zivotix Magic.</p>
          <p className="hero-desc-txt">{homeData.heroText}</p>
          <div className="get-started-btn">
            <div className="btn-to-start" onClick={() => navigate("/contact")}>Get Started</div>
          </div>
        </div>
        <div className="right-s-cont">
          <img src={DigitalImg} alt="" />
        </div>
      </div>

      <div className="about-s-box">
        <p className="about-title-s">
          Crafting Digital Experiences: Your Gateway to Online Success
        </p>
        <div className="why-choose-us" style={{ gap: "20px" }}>
          {sections.map((section, index) => {
            if (section.title === "whyUs") {
              return section.points.map((point, pointIndex) => (
                <div key={pointIndex}>
                  <h3>{point.title}</h3>
                  <p>{point.description}</p>
                </div>
              ));
            }
            return null;
          })}
        </div>
      </div>

      <div className="s-m-services">
        <p className="hero-txt-title">Our Utility</p>
        <p className="hero-desc-txt s-m-width" onClick={() => navigate('/services')}>
          {homeData.utilityText}
        </p>
        <section className="services">
          {homeData.services.map((service, index) => (
            <ServiceComponent
              simpleMode
              key={index}
              {...service}
              index={index}
            />
          ))}
        </section>
      </div>
      <div className="s-m-testimonial">
        <p className="hero-txt-title" style={{ color: "#fff" }}>
          Client Testimony Tales
        </p>
        <p className="s-m-client-txt">{homeData.ClientText}</p>
        <div className="s-m-width">
          <TestimonialPage />
        </div>
      </div>
      <div className="s-m-client-partners">
        <p className="hero-txt-title">
          Building Relationships: Proud Partners in Success
        </p>
        <OurClients />
      </div>
    </div>
  );
};

export default SimpleMode;
